import { Button, message, Modal } from "antd";
import React from "react";

export default function ShareModal({
  showShareModal,
  setShowShareModal,
  handleApprove2,
  hasSent,
  showSentDraftLink,
  sentDraftLink,
  sentDraftLinkRef,
  disabled,
}) {
  return (
    <Modal
      open={showShareModal}
      title="View Sent Draft"
      onCancel={() => setShowShareModal(false)}
      footer={
        !showSentDraftLink &&
        !hasSent && (
          <div style={{ display: "flex", justifyContent: "end", alignItems: "center", gap: 10 }}>
            <Button style={{ border: "1px solid #6b43B5", padding: "10px 20px" }} onClick={() => setShowShareModal(false)} disabled={disabled}>
              No
            </Button>

            <Button type="primary" onClick={() => handleApprove2("sent")} disabled={disabled}>
              Send
            </Button>
          </div>
        )
      }
    >
      {showSentDraftLink || hasSent ? (
        <div
          style={{
            backgroundColor: "#F6F5FD",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderRadius: 10,
            padding: "10px 20px",
            marginTop: 20,
          }}
        >
          <p id="sent-draft-link" ref={sentDraftLinkRef}>
            <a href={sentDraftLink} style={{ color: "#6B43B5" }} target="_blank">
              {sentDraftLink}
            </a>
          </p>

          <Button
            style={{ backgroundColor: "#E0DDF7", color: "#6B43B5" }}
            onClick={async () => {
              try {
                await navigator.clipboard.writeText(sentDraftLinkRef.current.textContent);
                message.success("Copied to clipboard");
              } catch (err) {
                message.error("Failed to copy to clipboard");
                console.error(err);
              }
            }}
          >
            copy
          </Button>
        </div>
      ) : (
        <>
          <p style={{ fontSize: 16, marginBottom: 0, marginTop: 10 }}>You didn't send any treatment plan.</p>
          <p style={{ fontSize: 16 }}>Are you ready to send it?</p>
        </>
      )}
    </Modal>
  );
}
